module.exports = __webpack_public_path__ + "img/s-4.919d5284.gif";